module.exports = __webpack_public_path__ + "img/avbi02c.a30d5b8c.png";